import { render, staticRenderFns } from "./TrainDataLayout.vue?vue&type=template&id=6b4cbf40&scoped=true&"
import script from "./TrainDataLayout.vue?vue&type=script&lang=js&"
export * from "./TrainDataLayout.vue?vue&type=script&lang=js&"
import style0 from "./TrainDataLayout.vue?vue&type=style&index=0&id=6b4cbf40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cbf40",
  null
  
)

export default component.exports